import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import { View } from '@zhike/ti-ui';
import styles from './styles';


export default class AccuracyRing extends React.Component {
  static propTypes = {
    accuracy: PropTypes.number,
    type: PropTypes.string,
    componentType: PropTypes.string,
  };

  static defaultProps = {
    accuracy: 0,
    type: 'gammar',
    componentType: 'evaluation', // 'senior' 组件类型有：测评版和国高版
  };
  constructor(props) {
    super(props);
    this.state = {
      accuracy1: 0,
    };
    this.animate = null;
  }

  componentDidMount() {
    const { accuracy, type, componentType } = this.props;
    setTimeout(() => {
      if (accuracy === 0) {
        global.document.getElementById(`${type}`).style.stroke = '#405C9A';
      } else {
        const c = componentType === 'senior' ? Math.PI * (50 * 2) : Math.PI * (90 * 2);
        const length = ((1 - accuracy) / 1) * c;
        global.document.getElementById(`${type}`).style.strokeDashoffset = length;
        global.document.getElementById(`${type}`).style.transition = 'stroke-dashoffset 0.5s cubic-bezier(.26,1.05,.91,1.21)';
      }
    }, 100);
    this.animate = setInterval(() => {
      if (this.state.accuracy1 === Math.round(this.props.accuracy * 100)) {
        clearInterval(this.animate);
        this.animate = null;
        return false;
      }
      const { accuracy1 } = this.state;
      this.setState({ accuracy1: accuracy1 + 1 });
    }, componentType === 'senior' ? 6 : 30);
  }

  render() {
    const { accuracy1 } = this.state;
    const { type, componentType } = this.props;
    return (
      <View className={styles.container}>
        <View className={styles.textContainer}>
          {
            componentType === 'senior' &&
            <span className={css(styles.accuracySenior)}>
              {accuracy1}<span className={css(styles.textSenior)}>%</span>
            </span>
          }
          {
            componentType !== 'senior' &&
            <View className={styles.text}>
              <View className={styles.accuracy}>{accuracy1}%</View>
              <View className={styles.textAccuray}>正确率</View>
            </View>
          }
        </View>
        <svg className={css(styles.svg)} width={componentType === 'senior' ? '120' : '220'} height={componentType === 'senior' ? '120' : '220'} viewport="0 0 0 0" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <circle
            className={componentType === 'senior' ? css(styles.circleSenior) : css(styles.circle)}
            r={componentType === 'senior' ? '50' : '90'}
            cx={componentType === 'senior' ? '60' : '110'}
            cy={componentType === 'senior' ? '60' : '110'}
            fill="transparent"
            strokeDasharray={componentType === 'senior' ? '314.16' : '565.50'}
            strokeDashoffset="0"
          />
          <circle
            className={componentType === 'senior' ? css(styles.loadingSenior) : css(styles.loading)}
            id={type}
            r={componentType === 'senior' ? '50' : '90'}
            cx={componentType === 'senior' ? '60' : '110'}
            cy={componentType === 'senior' ? '60' : '110'}
            strokeDasharray={componentType === 'senior' ? '314.16' : '565.50'}
            strokeDashoffset={componentType === 'senior' ? '314.16' : '565.50'}
          />
        </svg>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/common/accuracy_ring/index.js